import { QuestionForMain } from "@/components/features/_layouts/island/main/question";

import { InputTextFieldRHF } from "@/components/ui/form/fields-rhf/input-field/input-text";

import { useGoogleFreeBookingLinksSettingsContext } from "../../../_context";

export const FormWebsite = () => {
	const { form } = useGoogleFreeBookingLinksSettingsContext();
	const {
		register,
		formState: { errors },
	} = form;

	return (
		<QuestionForMain
			title={"公式サイトURL"}
			required
			inputChildren={
				<div className="flex flex-col gap-4">
					<p>公式サイトが存在しない場合は、CHILLNNで作成したページのURLを入力してください。</p>

					<InputTextFieldRHF
						className="w-2/3 min-w-72"
						errorMessage={errors?.webSite?.message}
						{...register("webSite")}
					/>
				</div>
			}
		/>
	);
};
